import { Layout } from "antd";
import { routes } from "../routes/routes";
import { Route, Routes } from "react-router-dom";

const { Content } = Layout;

export default function LayoutBody() {
  return (
    <Content style={{ 
      padding:"20px",
      overflow: 'auto', 
      height: 'calc(100vh - 64px - 40px)', 
    }}>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Content>
  );
}
